// extracted by mini-css-extract-plugin
module.exports = {"FaqA":"FaqA_FaqA__CP3yr"};